<template>
  <form 
    v-if="!submitted"
    @submit.prevent="handleContactFormSubmit"
  >
    <textarea
      id=""
      v-model="message"
      class="form-input"
      name=""
      cols="30"
      rows="6"
    />
    <div class="form-actions">
      <button 
        type="submit" 
        class="btn-blue btn-small btn-block"
      >
        Verstuur je vraag
        <Tooltip tool-tip-text="Om deze service GRATIS te kunnen blijven aanbieden openen we de pagina van een van onze partners na het verzenden van je vraag." />
      </button>
    </div>
  </form>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Tooltip from "@/components/ComponentTooltip";
import axios from 'axios';

export default {
  name: "Contact",
  components: {
    Tooltip
  },
  data() {
    return {
      message: this.message,
      submitted: false
    };
  },
  computed: {
    ...mapState({
      stateModal: state => state.openModal,
    })
  },
  methods: {
    ...mapActions(["contact"]),
    async handleContactFormSubmit() {

      this.submitted = true;

      axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_GATEWAY_API;
      axios.defaults.responseType = 'json';

      const params = {
        mailText: this.message,
        pagina: this.$route.path
      };

      try {
        // Maak de API-aanroep
        await axios.get('https://0ovja4ep62.execute-api.eu-west-2.amazonaws.com/' + process.env.NODE_ENV + '/sendMail', {params});
                
      } catch (err) {
        // In geval van een fout, sla de fout op
        this.error = 'Er is een fout opgetreden bij het ophalen van de data.';
      } finally {
        this.$store.dispatch("toggleModal", !this.stateModal);
        window.open('https://tc.tradetracker.net/?c=34975&m=2091628&a=480276&r=&u=', '_blank', 'width=800,height=600');
        this.loading = false;
      }

      this.submitted = true;
      const { message } = this;
      if (message) {
        this.contact({ message });
      }
    }
  }
};
</script>
